// Notification.jsx
import React, { useEffect } from 'react';

const Notification = ({ message, type, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 3000); // Auto-close after 3 seconds

        return () => {
            clearTimeout(timer); // Clear timeout on unmount or change
        };
    }, [onClose]);

    const backgroundColor = type === 'success' ? 'bg-green-500' : 'bg-red-500';

    return (
        <div className={`fixed bottom-4 right-4 ${backgroundColor} text-white px-4 py-2 rounded-md shadow-md`}>
            {message}
        </div>
    );
};

export default Notification;
